'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHiveIconSmallLight } from '@awesome.me/kit-94e593bf23/icons/kit/custom';
import { faXmark } from '@awesome.me/kit-94e593bf23/icons/sharp/light';

// set the app element for accessibility
// see react-modal docs for more info : https://reactcommunity.org/react-modal/

const MyModal = t0 => {
  const $ = _c(16);
  const {
    children,
    isOpen,
    setIsOpen,
    contentLabel,
    stickyFooter: t1
  } = t0;
  const stickyFooter = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  useEffect(_temp, t2);
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = function afterOpenModal() {};
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const afterOpenModal = t3;
  let t4;
  if ($[2] !== setIsOpen) {
    t4 = function closeModal() {
      setIsOpen(false);
    };
    $[2] = setIsOpen;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const closeModal = t4;
  const modalClassName = stickyFooter ? "relative max-h-[95%] my-5 mx-auto max-w-[500px] w-[90%] md:w-[50%] h-auto overscroll-contain overflow-hidden rounded transition-all duration-300 bg-white shadow pt-10 px-10 pb-0" : "relative max-h-[95%] my-5 mx-auto max-w-[500px] w-[90%] md:w-[50%] h-auto overscroll-contain overflow-x-hidden overflow-y-auto rounded transition-all duration-300 bg-white shadow p-10";
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FontAwesomeIcon icon={faXmark} className="text-xl" />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== closeModal) {
    t6 = <button type="button" onClick={closeModal} className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center text-light hover:text-dark transition-colors" aria-label="Close">{t5}</button>;
    $[5] = closeModal;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== children) {
    t7 = <div className="flex flex-col text-left">{children}</div>;
    $[7] = children;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== closeModal || $[10] !== contentLabel || $[11] !== isOpen || $[12] !== modalClassName || $[13] !== t6 || $[14] !== t7) {
    t8 = <><Modal className={modalClassName} overlayClassName="z-[1055] fixed outline-0 left-0 right-0 top-0 bottom-0 bg-modal-overlay flex items-center justify-center" isOpen={isOpen} onAfterOpen={afterOpenModal} onRequestClose={closeModal} bodyOpenClassName="ReactModal__Body--open" htmlOpenClassName="ReactModal__Html--open" contentLabel={contentLabel}>{t6}{t7}</Modal></>;
    $[9] = closeModal;
    $[10] = contentLabel;
    $[11] = isOpen;
    $[12] = modalClassName;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
export default MyModal;
function _temp() {
  Modal.setAppElement("#hivenext");
}